import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

import AppStoreButtons from "./AppStoreButtons";

import bgImage from "assets/images/WorkforceApp/web_bg3.jpeg";
import screenHome from "assets/images/WorkforceApp/phoneImage.png";
import screenClockIn from "assets/images/WorkforceApp/screen_clockin.png";

function Hero() {
  return (
    <MKBox
      sx={{
        position: "relative",
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        backgroundImage: `url(${bgImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <MKBox sx={{ position: "absolute", inset: 0, backgroundColor: "rgba(0,0,0,0.62)" }} />

      <Container sx={{ position: "relative", zIndex: 1, pt: "64px" }}>
        <Grid container spacing={6} alignItems="center">
          {/* Left: text + CTAs */}
          <Grid item xs={12} md={6}>
            <MKTypography
              variant="caption"
              sx={{
                color: "rgba(255,255,255,0.65)",
                fontWeight: 600,
                letterSpacing: "0.1em",
                textTransform: "uppercase",
                display: "block",
                mb: 2,
              }}
            >
              Now available on iOS &amp; Android
            </MKTypography>

            <MKTypography
              variant="h1"
              color="white"
              fontWeight="bold"
              sx={{ fontSize: { xs: "2.2rem", md: "3rem" }, lineHeight: 1.15, mb: 3 }}
            >
              Workforce Management
              <br />
              <MKTypography
                component="span"
                variant="inherit"
                sx={{ opacity: 0.5, color: "white !important" }}
              >
                Simplified.
              </MKTypography>
            </MKTypography>

            <MKTypography
              variant="body1"
              color="white"
              sx={{ opacity: 0.75, mb: 5, lineHeight: 1.8 }}
            >
              Track attendance, manage schedules, and calculate payroll — with GPS precision. Built
              for companies who manage field workers across multiple sites.
            </MKTypography>

            <AppStoreButtons variant="light" />
          </Grid>

          {/* Right: two phone screenshots */}
          <Grid item xs={12} md={6}>
            <MKBox
              display="flex"
              justifyContent="center"
              alignItems="flex-end"
              gap={2}
              sx={{ px: { xs: 4, md: 0 } }}
            >
              <MKBox
                component="img"
                src={screenHome}
                alt="Spechs app home screen"
                sx={{
                  width: { xs: "42%", md: "44%" },
                  borderRadius: 4,
                  boxShadow: "0 32px 80px rgba(0,0,0,0.5)",
                  transform: "translateY(24px)",
                }}
              />
              <MKBox
                component="img"
                src={screenClockIn}
                alt="Spechs app clock in screen"
                sx={{
                  width: { xs: "42%", md: "44%" },
                  borderRadius: 4,
                  boxShadow: "0 32px 80px rgba(0,0,0,0.5)",
                }}
              />
            </MKBox>
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Hero;
